import React, { useEffect, useRef, useState } from "react";
import axios, { AxiosResponse } from "axios";
import { DataTableWithoutButtons } from "components/DataTable/DataTableWithoutButtons";
import { AfDataType } from "utils/TableColumnData";
import handleWheel from "utils/handleOnWheel";
import { ListCommanWay, UpdateCommanWay } from "API/commonApi";
import { UseMutateFunction, useMutation, useQuery } from "@tanstack/react-query";
import { Img } from "components";
import moment from "moment";
import Swal from "sweetalert2";
import UseToast from "utils/AfToast";
import Select from "react-select";
import { object } from "yup";
import { useFormik } from "formik";
import { Link, useNavigate } from "react-router-dom";
import { utils, write, writeFile } from "xlsx";
import { saveAs } from "file-saver";
import {
  ArrowDownIcon,
  ArrowsUpDownIcon,
  ArrowUpIcon,
  PhotoIcon,
  DocumentArrowDownIcon,
  MagnifyingGlassIcon,
  ClipboardDocumentIcon,
} from "@heroicons/react/24/outline";
import { get_file_url } from "utils/lib-utils";
import { AfDateRangePicker } from "components/Input/AfDateRangePicker";
import { Button, Card, CardBody, CardHeader, Chip, Input, Spinner } from "@heroui/react";
import { Table, TableHeader, TableBody, TableColumn, TableRow, TableCell } from "@heroui/table";

const BookingReport: React.FC<any> = (props) => {
  const ADT = AfDataType;
  const [tableData, setTableData] = useState<any>([]);
  const [pickupData, setPickupData] = useState<any>({});

  const [agentId, setAgentId] = useState("");
  const [startDate, setStartDate] = useState<any>(moment().startOf("day").subtract(1, "days").format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState<any>(moment().endOf("day").format("YYYY-MM-DD"));
  const [query, setQuery] = useState<any>({
    /*date: {
      $gte: moment().startOf("day").subtract(7, "days"),
      $lte: moment().endOf("day"),
    },*/
    qry: `date >= '${moment().startOf("day").subtract(1, "days").format("YYYY-MM-DD HH:mm:ss")}' AND date <= '${moment()
      .endOf("day")
      .format("YYYY-MM-DD HH:mm:ss")}'`,
  });
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [fetchedData, setFetchedData] = useState([]);
  const [isDataAdded, setIsDataAdded] = useState(false);
  const [sortStat, setSortStat] = useState<any>({});

  const [nestedTables, setNestedTables] = useState<any>({});
  const [nestedSelectedOptions, setNestedSelectedOptions] = useState<any>({});

  let hardcode_json_data = [
    { status_code: 0, reason: "Shipment Delivered", action: "Success" },
    { status_code: 1, reason: "residence/office closed", action: "Re-Assign" },
    { status_code: 2, reason: "add incomplete/incorrect/not locatable", action: "Re-Assign" },
    { status_code: 3, reason: "no such consignee at given address", action: "Re-Assign" },
    { status_code: 4, reason: "consignee refused to accept", action: "Re-Assign" },
    { status_code: 5, reason: "RTO ( shipper request )", action: "Return" },
    { status_code: 6, reason: "need dept name/extn.no:unable to deliver", action: "Re-Assign" },
    { status_code: 7, reason: "consignee not available", action: "Re-Assign" },
    { status_code: 8, reason: "IN TRANSIT", action: "Re-Assign" },
    { status_code: 9, reason: "hold at location", action: "Re-Assign" },
    { status_code: 10, reason: "out of delivery area", action: "Re-Assign" },
    { status_code: 11, reason: "disturbance/natural disaster/strike ", action: "Re-Assign" },
    { status_code: 12, reason: "shipment handed over to agent/subcouriered pod no available", action: "Success" },
    { status_code: 13, reason: "consginee/shipper not ready to pay tax/demurrag ", action: "Re-Assign" },
    { status_code: 14, reason: "held at hub:regulatory paperwork reqd", action: "Re-Assign" },
    { status_code: 15, reason: "Shipment Missrouted due to wrong pincode/adddress", action: "Return" },
    { status_code: 16, reason: "shipment redirected on same airwaybill", action: "Re-Assign" },
    { status_code: 17, reason: "shipment redirected on new airwaybill", action: "Return" },
    { status_code: 18, reason: "held for duty/taxes/fees payment", action: "Re-Assign" },
    { status_code: 19, reason: "consigment partially deliverd", action: "Success" },
    { status_code: 20, reason: "shipment/piece missing", action: "Destroy" },
    { status_code: 21, reason: "shipment returned back to shipper", action: "CANCEL" },
    { status_code: 22, reason: "delivery area not accessible", action: "Re-Assign" },
    { status_code: 23, reason: "shipment partially deliverd", action: "Re-Assign" },
    { status_code: 24, reason: "please contact customer service", action: "Re-Assign" },
    { status_code: 25, reason: "attempt at secondary address", action: "Re-Assign" },
    { status_code: 26, reason: "shipment destroyed/sent for disposal", action: "Destroy" },
    { status_code: 27, reason: "UnDelivered", action: "Re-Assign" },
  ];
  hardcode_json_data[99] = { status_code: 99, reason: "Shipment Cancelled", action: "CANCEL" };
  hardcode_json_data[100] = { status_code: 100, reason: "Sent To Third Party", action: "Success" };
  hardcode_json_data[-1] = { status_code: -1, reason: "-", action: "-" };
  const [HARDCODE_JSON_STATUS_LIST] = useState<any>(hardcode_json_data);

  let HARDCORE_MBAG_STATUS = [
    { status_code: 0, reason: "PENDING" },
    { status_code: 1, reason: "flight delay due to bad weather" },
    { status_code: 2, reason: "late arrival scheduled.for next working day" },
    { status_code: 3, reason: "missed connection" },
    { status_code: 4, reason: "shipment off-loaded by airline security/space contraint" },
    { status_code: 5, reason: "flight/vehicle delayed cancelled" },
    { status_code: 6, reason: "misrouted in network" },
    { status_code: 7, reason: "scheduled for movement in network" },
    { status_code: 8, reason: "linehaul delayed accident/traffic-jam" },
    { status_code: 9, reason: "security cleared" },
    { status_code: 10, reason: "shipment under cooling by airline" },
    { status_code: 11, reason: "under security investigation" },
    { status_code: 12, reason: "please contact customer service" },
    { status_code: 13, reason: "shipment detained/seized by regulatory" },
    { status_code: 14, reason: "awaiting connection on next available flight" },
    { status_code: 15, reason: "Shipment Held by GST Deparment under investigation" },
  ];

  const defaultOptions: any = [{ value: 0, label: "Loading..." }];
  type OptionType = {
    value: number;
    label: string;
  };
  const columnData = [
    {
      label: "Reference Code",
      key: "pickup_code",
      type: ADT.TEXT,
    },
    {
      label: "Customer code",
      key: "customerCode",
      type: ADT.TEXT,
    },
    {
      label: "Product",
      key: "product",
      type: ADT.DB,
      db: "product",
      db_col: "product_name",
    },
    {
      label: "Origin City",
      key: "org_city",
      type: ADT.DB,
      db: "city",
      db_col: "city_name",
    },
    {
      label: "Destination City",
      key: "dest_city",
      type: ADT.DB,
      db: "city",
      db_col: "city_name",
    },

    {
      label: "Dox/Non Dox",
      key: "isdoc",
      type: ADT.SELECT,
      options: [
        { value: "0", label: "NON DOX" },
        { value: "1", label: "DOX" },
      ],
    },

    {
      label: "Shipper",
      key: "shipper",
      type: ADT.TEXT,
    },
    {
      label: "Consignee",
      key: "consignee",
      type: ADT.TEXT,
    },
    {
      label: "Holiday",
      key: "holiday",
      type: ADT.SELECT,
      options: [
        { value: "1", label: "Yes" },
        { value: "0", label: "No" },
      ],
    },
    {
      label: "10:30",
      key: "ten_30",
      type: ADT.SELECT,
      options: [
        { value: "1", label: "Yes" },
        { value: "0", label: "No" },
      ],
    },
    {
      label: "Status",
      key: "status",
      type: ADT.SELECT,
      options: [
        { value: "0", label: "Deliver" },
        { value: "-1", label: "Non Deliver" },
        { value: "99", label: "Cancelled" },
        { value: "5", label: "RTO" },
      ],
    },
    {
      label: "Outbound/Inbound",
      key: "in_out_bound",
      type: ADT.SELECT,
      options: [
        { value: "", label: "All" },
        { value: "out", label: "Outbound" },
        { value: "in", label: "Inbound" },
      ],
    },
  ];

  useEffect(() => {
    let proms = [];

    let nestedApiData = {};
    columnData.forEach((cd) => {
      if (cd.type == ADT.DB) {
        proms.push(
          new Promise((res, rej) => {
            ListCommanWay(`/admin/${cd.db}/list`, {}, { paginate: 1000 })
              .then((x) => {
                let data: OptionType[] = [];
                if (x.status == "SUCCESS") {
                  let ary = [...x.data.data];

                  data = ary.map((d) => {
                    if (cd.db == "country") {
                      return { value: d.country_code, label: d[cd.db_col] };
                    } else if (cd.db == "product") {
                      return { value: d.product_code, label: d[cd.db_col] };
                    } else if (cd.db == "city") {
                      return { value: d[cd.db_col], label: d[cd.db_col] };
                    } else {
                      return { value: d.id, label: d[cd.db_col] };
                    }
                  });
                  nestedApiData[cd.db] = data;
                }
                res(1);
              })
              .catch((c) => {
                res(0);
              });
          })
        );
      }
    });

    Promise.all(proms).then((x) => {
      setNestedTables(nestedApiData);
    });
  }, []);

  const { isFetching, isLoading, refetch } = useQuery(
    ["admin_booking_report_list"],
    () =>
      ListCommanWay(
        "/admin/booking/list",
        {
          ...query,
          qry2: values,
        },
        {}
      ),
    {
      keepPreviousData: true,
      onSuccess(data) {
        if (data.status == "SUCCESS") {
          console.log("data.data", data.data);
          setTableData(data.data.data);
          if (data.data.pickupInfo?.id) {
            setPickupData(data.data.pickupInfo);
          }
        } else {
          setTableData([]);
          setPickupData({});
        }
      },
      onError: (data) => {
        setTableData([]);
        setPickupData({});
      },
    }
  );

  useEffect(() => {
    refetch();
  }, [query]);

  const __handleSubmit = async () => {
    setIsDataAdded(!isDataAdded);

    setQuery({
      qry: `date >= '${startDate ? startDate : moment().startOf("day").subtract(7, "days").format("YYYY-MM-DD HH:mm:ss")}' AND date <= '${
        endDate ? endDate : moment().endOf("day").format("YYYY-MM-DD HH:mm:ss")
      }'`,
    });

    /*setQuery({
      //agent_id: Number(agentId),
      date: {
        $gte: startDate ? startDate : moment().startOf("day").subtract(7, "days"),
        $lte: endDate ? endDate : moment().endOf("day"),
      },
    });*/
  };

  const tableRef = useRef(null);
  const exportToExcel = async () => {
    const table = tableRef.current;

    const tableClone = table.cloneNode(true);

    const tfoot = tableClone.getElementsByTagName("tfoot");
    if (tfoot.length > 0) {
      tfoot[0].remove();
    }
    const toIgnore = tableClone.querySelectorAll(".ignore-excel");
    if (toIgnore.length > 0) {
      toIgnore[0].remove();
    }

    const rows = tableClone.querySelectorAll("tbody tr");
    rows.forEach((row: any) => {
      const dateCell = row.cells[1]; // Second column is at index 1
      dateCell.innerText = moment(dateCell.innerText, "DD-MM-YYYY").format("YYYY-MM-DD");
      if (dateCell.innerText == "Invalid date") {
        dateCell.innerText = "";
      }

      const dateCell2 = row.cells[11]; // Second column is at index 11
      dateCell2.innerText = moment(dateCell2.innerText, "DD/MM/YYYY HH:mm").format("YYYY-MM-DD HH:mm");
      if (dateCell2.innerText == "Invalid date") {
        dateCell2.innerText = "";
      }
      console.log(dateCell2.innerText);
    });

    const ws = utils.table_to_sheet(tableClone);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Sheet1");

    Object.keys(ws).forEach((key) => {
      if (key.startsWith("!")) return;

      let cell = ws[key];
      if (cell && cell.h && typeof cell.h === "string") {
        cell.h = null;
      }
      if (cell && cell.l) {
        delete cell.l;
      }
    });

    const wbout = write(wb, { bookType: "xlsx", type: "array" });

    const blob = new Blob([wbout], { type: "application/octet-stream" });
    saveAs(blob, "MIS.xlsx");
  };

  const GET_SORT_ICON = (key, info) => {
    switch (sortStat[key]) {
      case "asc":
        return (
          <ArrowDownIcon
            className="h-4 inline-block"
            onClick={() => {
              handleSort(key, info);
            }}
          />
        );
      case "desc":
        return (
          <ArrowUpIcon
            className="h-4 inline-block"
            onClick={() => {
              handleSort(key, info);
            }}
          />
        );
      default:
        return (
          <ArrowsUpDownIcon
            className="h-4 inline-block"
            onClick={() => {
              handleSort(key, info);
            }}
          />
        );
    }
  };

  const handleSort = (key, info) => {
    let data = [...tableData];
    let order = sortStat[key] == "asc" ? "desc" : "asc";

    let sortedData = data.sort((a, b) => {
      let valueA, valueB;

      if (key == "date") {
        // Sort by actual date value, not formatted string
        valueA = moment(a.date).valueOf();
        valueB = moment(b.date).valueOf();
      } else if (key == "days") {
        valueA = a.status == 0 && a.pod_updatedAt ? moment(a.pod_updatedAt).diff(a.date, "days") || 0 : -Infinity;
        valueB = b.status == 0 && b.pod_updatedAt ? moment(b.pod_updatedAt).diff(b.date, "days") || 0 : -Infinity;
      } else if (key == "hours") {
        valueA =
          a.status == 0 && a.pod_updatedAt
            ? moment(a.pod_updatedAt).diff(
                moment(a.date).set({
                  hour: moment(a.createdAt).hour(),
                  minute: moment(a.createdAt).minute(),
                }),
                "minutes"
              ) || 0
            : -Infinity;
        valueB =
          b.status == 0 && b.pod_updatedAt
            ? moment(b.pod_updatedAt).diff(
                moment(b.date).set({
                  hour: moment(b.createdAt).hour(),
                  minute: moment(b.createdAt).minute(),
                }),
                "minutes"
              ) || 0
            : -Infinity;
      } else if (key == "a_weight") {
        //r.a_weight || r.realWeight
        valueA = a.a_weight || a.realWeight || 0;
        valueB = b.a_weight || b.realWeight || 0;
      } else {
        // Extract the value using the keyPath (e.g., "invoice_data.idpaid")
        valueA = key.split(".").reduce((obj, k) => obj?.[k], a) || "";
        valueB = key.split(".").reduce((obj, k) => obj?.[k], b) || "";
      }

      // Handle sorting for different data types
      if (valueA < valueB) return order === "asc" ? -1 : 1;
      if (valueA > valueB) return order === "asc" ? 1 : -1;
      return 0; // If equal
    });
    let _sortStat = { ...sortStat };
    _sortStat[key] = order;
    setSortStat(_sortStat);
    setTableData(sortedData);
  };

  const BASE_URL = process.env.REACT_APP_BACKEND_URL;
  const userD = (() => { const auth = localStorage.getItem("auth"); return auth ? JSON.parse(auth) : {}; })();
  const [userDetails, setUserDetails] = useState<any>(userD?.state?.user || {});

  const { handleSubmit, handleBlur, values, handleChange, errors, setValues, touched, setFieldValue } = useFormik({
    validationSchema: object().shape({}),
    initialValues: {
      pickup_code: "",
      customerCode: "",
      product: "",
      org_city: "",
      dest_city: "",
      isdoc: "",
      shipper: "",
      consignee: "",
      holiday: "",
      ten_30: "",
      status: "",
    },
    onSubmit: async (values, { resetForm }) => {
      console.log("valuesssss", values);
    },
  });

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 font-inter">
      {/* Header */}
      <div className="bg-gradient-to-r from-slate-800 via-slate-700 to-slate-800 px-6 py-4 shadow-lg">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-white/10 backdrop-blur rounded-xl flex items-center justify-center">
              <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
            </div>
            <div>
              <h1 className="text-xl font-bold text-white">Booking Report</h1>
  
            </div>
          </div>
          <div className="flex items-center gap-2">
            <Chip color="primary" variant="flat" className="bg-white/10 text-white">
              {tableData.length} Records
            </Chip>
          </div>
        </div>
      </div>

      {/* Filters Card */}
      <div className="px-4 -mt-4">
        <Card className="shadow-xl border-none overflow-visible">
          <CardBody className="p-4 overflow-visible">
            <form
              className="flex flex-col gap-4"
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit(e);
              }}
            >
              {/* Compact Inline Filters */}
              <div className="flex flex-wrap items-end gap-3">
                <AfDateRangePicker
                  label="Date Range"
                  startDate={startDate}
                  endDate={endDate}
                  setStartDate={setStartDate}
                  setEndDate={setEndDate}
                />

                {columnData.map((c) => {
                  switch (c.type) {
                    case ADT.NUMBER:
                      return (
                        <div key={"general_" + c.key} className="w-28">
                          <Input
                            type="number"
                            size="sm"
                            variant="bordered"
                            label={c.label}
                            labelPlacement="outside-top"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            name={c.key}
                            value={values[c.key]}
                            classNames={{ inputWrapper: "bg-slate-50 h-8", label: "text-xs" }}
                          />
                        </div>
                      );
                    case ADT.TEXT:
                      return (
                        <div key={"general_" + c.key} className="w-36">
                          <Input
                            type="text"
                            size="sm"
                            variant="bordered"
                            label={c.label}
                            labelPlacement="outside-top"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            name={c.key}
                            value={values[c.key]}
                            classNames={{
                              input: "border-none",
                              inputWrapper: "bg-slate-50 h-8",
                              label: "text-xs",
                            }}
                          />
                        </div>
                      );
                    case ADT.DB:
                      return (
                        <div key={"general_" + c.key} className="min-w-[140px]">
                          <label className="block mb-1 text-xs font-medium text-slate-600">{c.label}</label>
                          <Select
                            key={"select-" + (nestedTables[c.db] ? nestedTables[c.db].length : "undef")}
                            className="text-xs z-50"
                            classNamePrefix="select"
                            styles={{
                              control: (base) => ({ ...base, minHeight: "32px", backgroundColor: "rgb(248 250 252)", fontSize: "12px" }),
                              valueContainer: (base) => ({ ...base, padding: "0 6px" }),
                              placeholder: (base) => ({ ...base, fontSize: "12px" }),
                              option: (base) => ({ ...base, fontSize: "12px", padding: "6px 10px" }),
                            }}
                            options={nestedTables[c.db] ? nestedTables[c.db] : defaultOptions}
                            onChange={(el: any) => {
                              if (c.key == "org_city" || c.key == "dest_city") {
                                setFieldValue(c.key, el.map((x: any) => x.value).join(",") || "");
                              } else {
                                setFieldValue(c.key, el?.value || "");
                              }
                            }}
                            isMulti={c.key == "org_city" || c.key == "dest_city"}
                            isClearable
                            name={c.key}
                            placeholder={c.label}
                          />
                        </div>
                      );
                    case ADT.SELECT:
                      return (
                        <div key={"general_" + c.key} className="min-w-[120px]">
                          <label className="block mb-1 text-xs font-medium text-slate-600">{c.label}</label>
                          <Select
                            className="text-xs z-50"
                            classNamePrefix="select"
                            styles={{
                              control: (base) => ({ ...base, minHeight: "32px", backgroundColor: "rgb(248 250 252)", fontSize: "12px" }),
                              valueContainer: (base) => ({ ...base, padding: "0 6px" }),
                              placeholder: (base) => ({ ...base, fontSize: "12px" }),
                              option: (base) => ({ ...base, fontSize: "12px", padding: "6px 10px" }),
                            }}
                            options={c?.options}
                            onChange={(el) => setFieldValue(c.key, el?.value || "")}
                            isClearable
                            name={c.key}
                            placeholder={c.label}
                          />
                        </div>
                      );
                    default:
                      return null;
                  }
                })}

                {/* Action Buttons inline */}
                <Button
                  size="sm"
                  variant="flat"
                  color="primary"
                  className="h-8 mt-5"
                  startContent={<DocumentArrowDownIcon className="w-4 h-4" />}
                  onPress={exportToExcel}
                >
                  Export
                </Button>
                <Button
                  size="sm"
                  color="success"
                  className="h-8 mt-5"
                  type="button"
                  onPress={__handleSubmit}
                  isLoading={isLoading || isFetching}
                  startContent={!isLoading && !isFetching && <MagnifyingGlassIcon className="w-4 h-4" />}
                >
                  Search
                </Button>
              </div>
            </form>
          </CardBody>
        </Card>
      </div>

      {/* Results Table */}
      <div className="px-4 mt-4 pb-8">
        <Card className="shadow-xl border-none overflow-hidden">
          <CardHeader className="bg-gradient-to-r from-slate-50 to-white border-b border-slate-100 px-4 py-3">
            <div className="flex items-center gap-2">
              <span className="w-8 h-8 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-lg flex items-center justify-center">
                <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 10h16M4 14h16M4 18h16" />
                </svg>
              </span>
              <h2 className="text-lg font-bold text-slate-800">Results</h2>
              {tableData.length > 0 && (
                <Chip size="sm" variant="flat" color="primary" className="ml-2">
                  {tableData.length} shipments
                </Chip>
              )}
            </div>
          </CardHeader>
          <CardBody className="p-0 overflow-x-auto">
            <table className="w-full text-sm" ref={tableRef} id="my-table-1">
              <thead className="bg-slate-50 sticky top-0">
                <tr>
                  <th className="px-3 py-2 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider border-b border-slate-200">
                    Sr.
                  </th>
                  <th className="px-3 py-2 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider border-b border-slate-200"></th>
                  <th
                    className="px-3 py-2 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider border-b border-slate-200 cursor-pointer hover:bg-slate-100"
                    onClick={() => handleSort("date", "")}
                  >
                    Date {GET_SORT_ICON("date", "")}
                  </th>
                  <th
                    className="px-3 py-2 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider border-b border-slate-200 cursor-pointer hover:bg-slate-100"
                    onClick={() => handleSort("awb_no", "")}
                  >
                    AWB {GET_SORT_ICON("awb_no", "")}
                  </th>
                  <th className="px-3 py-2 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider border-b border-slate-200">
                    Shipper
                  </th>
                  <th className="px-3 py-2 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider border-b border-slate-200">
                    Consignee
                  </th>
                  <th
                    className="px-3 py-2 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider border-b border-slate-200 cursor-pointer hover:bg-slate-100"
                    onClick={() => handleSort("shipper_city", "")}
                  >
                    Origin {GET_SORT_ICON("shipper_city", "")}
                  </th>
                  <th
                    className="px-3 py-2 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider border-b border-slate-200 cursor-pointer hover:bg-slate-100"
                    onClick={() => handleSort("destination", "")}
                  >
                    Dest {GET_SORT_ICON("destination", "")}
                  </th>
                  <th
                    className="px-3 py-2 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider border-b border-slate-200 cursor-pointer hover:bg-slate-100"
                    onClick={() => handleSort("a_weight", "")}
                  >
                    WT {GET_SORT_ICON("a_weight", "")}
                  </th>
                  {userDetails.userType != 9 && (
                    <th className="px-3 py-2 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider border-b border-slate-200">
                      Code
                    </th>
                  )}
                  <th
                    className="px-3 py-2 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider border-b border-slate-200 cursor-pointer hover:bg-slate-100"
                    onClick={() => handleSort("status", "")}
                  >
                    Status {GET_SORT_ICON("status", "")}
                  </th>
                  <th className="px-3 py-2 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider border-b border-slate-200">
                    POD Time
                  </th>
                  {userDetails.userType != 9 && (
                    <th
                      className="px-3 py-2 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider border-b border-slate-200 cursor-pointer hover:bg-slate-100"
                      onClick={() => handleSort("pickup_code", "")}
                    >
                      Ref {GET_SORT_ICON("pickup_code", "")}
                    </th>
                  )}
                  <th
                    className="px-3 py-2 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider border-b border-slate-200 cursor-pointer hover:bg-slate-100"
                    onClick={() => handleSort("days", "")}
                  >
                    Days {GET_SORT_ICON("days", "")}
                  </th>
                  <th
                    className="px-3 py-2 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider border-b border-slate-200 cursor-pointer hover:bg-slate-100"
                    onClick={() => handleSort("hours", "")}
                  >
                    Hrs {GET_SORT_ICON("hours", "")}
                  </th>
                </tr>
              </thead>
              <tbody>
                {(isLoading || isFetching) && (
                  <tr>
                    <td colSpan={15} className="text-center py-12">
                      <Spinner size="lg" color="primary" />
                      <p className="text-slate-500 mt-2">Loading data...</p>
                    </td>
                  </tr>
                )}
                {!isLoading && !isFetching && !tableData.length && !pickupData.id && (
                  <tr>
                    <td colSpan={15} className="text-center py-12">
                      <div className="flex flex-col items-center">
                        <svg className="w-16 h-16 text-slate-300 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={1}
                            d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                          />
                        </svg>
                        <p className="text-slate-500 font-medium">No data found</p>
                        <p className="text-slate-400 text-sm">Try adjusting your filters</p>
                      </div>
                    </td>
                  </tr>
                )}
                {!tableData.length && pickupData.id && (
                  <tr className="hover:bg-slate-50 transition-colors border-b border-slate-200">
                    <td className="px-3 py-2 text-slate-600 border-r border-slate-100">1</td>
                    <td className="px-3 py-2 border-r border-slate-100">-</td>
                    <td className="px-3 py-2 text-slate-600 border-r border-slate-100">-</td>
                    <td className="px-3 py-2 border-r border-slate-100">
                      <Chip size="sm" color="warning" variant="flat">
                        NO AWB
                      </Chip>
                    </td>
                    <td className="px-3 py-2 font-medium text-slate-800 border-r border-slate-100">{pickupData.shipper_sh}</td>
                    <td className="px-3 py-2 text-slate-600 border-r border-slate-100">{pickupData.consignee_cgnee}</td>
                    <td className="px-3 py-2 text-slate-600 border-r border-slate-100">{pickupData.shipper_city}</td>
                    <td className="px-3 py-2 text-slate-600 border-r border-slate-100">{pickupData.consignee_city}</td>
                    <td className="px-3 py-2 border-r border-slate-100">-</td>
                    <td className="px-3 py-2 text-slate-600 border-r border-slate-100">{pickupData.customer_code}</td>
                    <td className="px-3 py-2 border-r border-slate-100">-</td>
                    <td className="px-3 py-2 border-r border-slate-100">-</td>
                    <td className="px-3 py-2 border-r border-slate-100">-</td>
                    <td className="px-3 py-2 border-r border-slate-100">-</td>
                    <td className="px-3 py-2 text-blue-600 font-medium">{pickupData.pickup_code ? <a target="_blank" href={`/pickup/tracking?awb=${pickupData.pickup_code}`}>{pickupData.pickup_code}</a> : "-"}</td>
                  </tr>
                )}
                {tableData.map((r, sr) => {
                  const getStatusChip = () => {
                    if (r.pickup_date_time) {
                      const pickupStatuses = ["Pickup Processed", "Pickup Done", "Pickup Cancel", "Pickup Reschedule", "Confirmed"];
                      const statusText = pickupStatuses[r.status] || "Pickup Pending";
                      const colors: any = { "Pickup Done": "success", "Pickup Cancel": "danger", "Pickup Pending": "warning" };
                      return (
                        <Chip size="sm" color={colors[statusText] || "primary"} variant="flat">
                          {statusText}
                        </Chip>
                      );
                    }
                    if (r.status == 0)
                      return (
                        <Chip size="sm" color="success" variant="flat">
                          Delivered
                        </Chip>
                      );
                    if (r.status == 99)
                      return (
                        <Chip size="sm" color="danger" variant="flat">
                          Cancelled
                        </Chip>
                      );
                    if (r.status == 5)
                      return (
                        <Chip size="sm" color="warning" variant="flat">
                          RTO
                        </Chip>
                      );
                    if (r.status == 100)
                      return (
                        <Chip size="sm" color="secondary" variant="flat">
                          3rd Party
                        </Chip>
                      );
                    return (
                      <Chip size="sm" color="default" variant="flat">
                        {HARDCODE_JSON_STATUS_LIST[r.status]?.reason || "Booked"}
                      </Chip>
                    );
                  };

                  return (
                    <tr
                      className={`hover:bg-slate-50 transition-colors border-b border-slate-200 ${
                        r.pickup_date_time ? "bg-amber-50" : !r.a_isActive ? "bg-red-50" : ""
                      }`}
                      key={`sometr-${sr}`}
                    >
                      <td className="px-3 py-2 text-slate-500 text-xs border-r border-slate-100">{sr + 1}</td>
                      <td className="px-3 py-2 border-r border-slate-100">
                        {r.parcelPhoto && (
                          <a href={get_file_url(r.parcelPhoto || "")} target="_blank" className="text-blue-500 hover:text-blue-700">
                            <PhotoIcon className="w-4 h-4" />
                          </a>
                        )}
                      </td>
                      <td className="px-3 py-2 text-slate-600 whitespace-nowrap border-r border-slate-100">
                        {moment(r.date).format("DD/MM/YYYY")}
                      </td>
                      <td className="px-3 py-2 border-r border-slate-100">
                        <div className="flex items-center gap-1">
                          <a
                            target="_blank"
                            href={`/pod/tracking?awb=${r.awb_no}`}
                            className="text-blue-600 hover:text-blue-800 font-medium hover:underline"
                          >
                            {r.awb_no}
                          </a>
                          <button
                            onClick={() => {
                              navigator.clipboard.writeText(r.awb_no);
                              UseToast("AWB copied to clipboard", "success");
                            }}
                            className="p-1 hover:bg-gray-100 rounded"
                            title="Copy AWB"
                          >
                            <ClipboardDocumentIcon className="h-4 w-4 text-gray-500 hover:text-blue-600" />
                          </button>
                        </div>
                      </td>
                      <td
                        className="px-3 py-2 font-medium text-slate-800 max-w-[220px]  border-r border-slate-100"
                        title={r.shipper_sh}
                      >
                        {r.shipper_sh}
                      </td>
                      <td className="px-3 py-2 text-slate-600 text-xs max-w-[220px]  border-r border-slate-100" title={r.consignee}>
                        {r.consignee}
                      </td>
                      <td className="px-3 py-2 text-slate-600 border-r border-slate-100">{r.shipper_city}</td>
                      <td className="px-3 py-2 text-slate-600 border-r border-slate-100">{r.destination}</td>
                      <td className="px-3 py-2 font-medium text-slate-800 border-r border-slate-100">
                        {r.a_weight || r.realWeight || "-"}
                      </td>
                      {userDetails.userType != 9 && (
                        <td className="px-3 py-2 text-slate-800 text-xs border-r border-slate-100">{r.customer_code}</td>
                      )}
                      <td className="px-3 py-2 border-r border-slate-100  ">{getStatusChip()}</td>
                      <td className="px-3 py-2 text-slate-800 text-xs whitespace-nowrap border-r border-slate-100">
                        {r.status == 0 && r.pod_updatedAt ? moment(r.pod_updatedAt).format("DD/MM/YY HH:mm") : "-"}
                      </td>
                      {userDetails.userType != 9 && (
                        <td className="px-3 py-2 text-primary underline text-xs border-r border-slate-100">{r.pickup_code ? <a target="_blank" href={`/pickup/tracking?awb=${r.pickup_code}`}>{r.pickup_code}</a> : "-"}</td>
                      )}
                      <td className="px-3 py-2 border-r border-slate-100">
                        {r.status == 0 && r.pod_updatedAt ? (
                          <Chip size="sm" variant="flat" color="primary">
                            {moment(r.pod_updatedAt).diff(r.date, "d") || "0"}d
                          </Chip>
                        ) : (
                          "-"
                        )}
                      </td>
                      <td className="px-3 py-2 text-slate-600 text-xs whitespace-nowrap">
                        {r.status == 0 && r.pod_updatedAt
                          ? (() => {
                              const diffMinutes = moment(r.pod_updatedAt).diff(
                                moment(r.date).set({
                                  hour: moment(r.createdAt).hour(),
                                  minute: moment(r.createdAt).minute(),
                                }),
                                "minutes"
                              );
                              const hours = Math.floor(diffMinutes / 60);
                              const minutes = diffMinutes % 60;
                              return `${hours}h ${minutes}m`;
                            })()
                          : "-"}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default BookingReport;
